/**
 * PrimeReact Configuration
 * Centralized configuration for PrimeReact components
 */

export const primeReactConfig = {
  ripple: true,
  inputStyle: 'outlined' as const,
  locale: 'en',
  appendTo: 'self' as const,
  cssTransition: true,
  autoZIndex: true,
  /**
   * Set baseZIndex to 1000 to ensure all PrimeReact overlays (dropdowns, datepickers,
   * modals, etc.) calculate their dynamic z-indexes starting from 1000.
   * PrimeReact's ZIndexUtils will increment from this base, ensuring overlays
   * always appear above MUI modals without hardcoded fixed values that conflict
   * with dynamic z-index management.
   *
   * Example: Modal might get z-index: 1100, Overlay might get 1101, etc.,
   * allowing PrimeReact to maintain proper layering based on component hierarchy.
   */
  baseZIndex: 1000,
  hideOverlaysOnDocumentScrolling: false,
  pt: {
    // Global pass-through options for all PrimeReact components
    // Can be used to apply custom classes or styles globally
  },
  ptOptions: {
    mergeSections: true,
    mergeProps: false,
  },
};
